import {
  InteractionRequiredAuthError,
  PublicClientApplication,
} from '@azure/msal-browser';
import {
  graphConfig,
  loginRequest,
  msalConfig,
  tokenRequest,
} from './msalConfig';

export const login = async () => {
  try {
    await msalInstance.loginRedirect(loginRequest);
  } catch (error) {
    console.error('Login failed:', error);
    msalInstance.loginRedirect(loginRequest);
  }
};

export const logout = () => {
  msalInstance.logoutRedirect({
    postLogoutRedirectUri: '/',
  });
};

export const getAccount = () => {
  const accounts = msalInstance.getAllAccounts();
  return accounts.length > 0 ? accounts[0] : null;
};

export const getWebApiToken = async (): Promise<string | null> => {
  const account = getAccount();
  if (!account) return null;

  try {
    const tokenResponse = await msalInstance.acquireTokenSilent({
      scopes: tokenRequest.scopes,
      account: account,
    });
    return tokenResponse.accessToken;
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      await msalInstance.acquireTokenRedirect({
        scopes: tokenRequest.scopes,
        prompt: 'consent',
      });
    }
    return null;
  }
};

export const getGraphToken = async (): Promise<string | null> => {
  const account = getAccount();
  if (!account) return null;

  try {
    const tokenResponse = await msalInstance.acquireTokenSilent({
      scopes: graphConfig.scopes,
      account: account,
    });
    return tokenResponse.accessToken;
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      await msalInstance.acquireTokenRedirect({
        scopes: graphConfig.scopes,
      });
    }
    return null;
  }
};

export const msalInstance = new PublicClientApplication(msalConfig);
